import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { TegelModule } from '@scania/tegel-angular-17';
import {
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import {
  PublicClientApplication,
  IPublicClientApplication,
  InteractionType,
} from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApiAuthInterceptor } from './core/interceptors/api-auth.interceptor';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';

export const API_SCOPE = environment.auth.apiScope;

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.auth.clientId,
    authority: environment.auth.authority,
    redirectUri: environment.redirectUri,
    postLogoutRedirectUri: environment.redirectUri,
  },
});

export function MSALInstanceFactory(): IPublicClientApplication {
  return msalInstance;
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [environment.auth.apiScope],
    },
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      [environment.urlApi, [environment.auth.apiScope]],
      [`${environment.urlApi}api/`, [environment.auth.apiScope]],
      ['https://graph.microsoft.com/v1.0/me', environment.auth.graphScopes],
    ]),
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      TegelModule,
      MsalModule.forRoot(
        MSALInstanceFactory(),
        MSALGuardConfigFactory(),
        MSALInterceptorConfigFactory(),
      ),
    ),
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiAuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
  ],
};
